"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var auth_1 = require("./auth");
var token_1 = require("./token");
exports.Token = token_1.default;
exports.default = auth_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/auth-client/lib/index.js
// module id = 731
// module chunks = 0